const EN_GB = {
    COUNTRY_CODE: 'GB',
    ID: 'en-gb',
    NUMBER_FORMAT: {
        CURRENCY_DESCRIPTION: 'Pound sterling',
        CURRENCY_SYMBOL: '\u00a3',
        DECIMAL_SEPARATOR: '.',
        GROUP_SEPARATOR: ',',
    },
};
export { EN_GB, };
//# sourceMappingURL=en-gb.js.map